import { Aggregate } from './aggregate';
import { FilterHandler } from '../shared/filter-handler';

import { Ship } from './ship';
import { Specie } from './specie';

export class DiscardAggregate extends Aggregate {
  constructor(values: Object = {}) {
    super();
    Object.assign(this, values);
  }

  apiMap(values: Object = {}) {
    const discard = new DiscardAggregate(values);

    // Map totals by year
    discard.totals = [];
    for (const value in values) {
      if (values.hasOwnProperty(value)) {
        const parts = value.split('_');
        if (parts[0] === 'total') {
          discard.addTotal(parts[1], values[value]);
        }
      }
    }

    return discard;
  }
}

export class DiscardAggregateFilter extends FilterHandler {
  specie: Specie[] = [];
  ship: Ship[] = [];
  ship_type: string;
  start_date: string;
  end_date: string;
  data_type: string;

  constructor(values: Object = {}) {
    super();

    this.specie = [];
    this.ship = [];
    this.ship_type = '';
    this.start_date = '';
    this.end_date = '';
    this.data_type = '';

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/discard-aggregate.ts